import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedPrice } from 'dibs-buyer-price';

export const REGION_CODES = {
    REST_OF_WORLD: 'REST_OF_WORLD',
};

export const FAVORABLE_WHITE_GLOVE_PRICE = 150;

/** Returns true if price is greater than some amount in U.S.D.
 * @param {Array} convertedAmountList - List of converted amounts.
 * @param {Number} threshold - the threshold in U.S.D.
 * @returns {Boolean}
 */
export const isPriceAboveThreshold = ({
    convertedAmountList,
    threshold = FAVORABLE_WHITE_GLOVE_PRICE,
}) => {
    if (!convertedAmountList) {
        return false;
    }
    const result = convertedAmountList.find(p => p.currency === 'USD');
    return !!result && result.amount > threshold;
};

/**
Returns numerical shipping price amount
 *
 * @param {Array} convertedAmountList - List of converted amounts.
 * @param {String} currency - User currency.
 * @returns {Number}
 */
export const getShippingPriceAmount = ({ convertedAmountList, currency }) => {
    if (!convertedAmountList) {
        return null;
    }
    const { amount } = convertedAmountList.find(p => p.currency === currency); // find amount by currency
    return amount;
};

/**
 * Returns formatted shipping price.
 *
 * @param {Array} convertedAmountList - List of converted amounts.
 * @param {String} currency - User currency.
 * @returns {String}
 */
export const getShippingPrice = ({ convertedAmountList, currency, shortMessage }) => {
    if (!convertedAmountList) {
        return null;
    }
    const amount = getShippingPriceAmount({ convertedAmountList, currency });
    let price = <FormattedPrice currency={currency} value={amount} />;

    if (amount === 0) {
        price = shortMessage ? (
            <FormattedMessage id="shippingHelpers.free" defaultMessage="Free" />
        ) : (
            <FormattedMessage id="shippingHelpers.freeShipping" defaultMessage="Free Shipping" />
        );
    }
    return price;
};
